export function anchorLinks() {
    const $links = $(".anchor-link, .anchors-list a");

    $links.click(function (e) {
        e.preventDefault();
        let $url = $(this).attr("href");
        let parseUrl = $url.split('#');
        let id = '#' + parseUrl[1];

        let targetElement = $(id);
        let elementTop = targetElement.offset().top;
        let headerHeight = $(".header").innerHeight();
        let top = elementTop - (headerHeight + 10);

        $("body, html").animate({scrollTop: top}, 500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchorLinks.js